declare global {
    interface Window {
        ENV?: {
            VITE_FRONTEND_URL: string;
            VITE_VELA_WEB_PORTAL_BACKEND_URL: string;
            VITE_TRACK_I18N_KEYS?: string;
            VITE_DOWNLOAD_URL_WINDOWS?: string;
            VITE_DOWNLOAD_URL_MAC?: string;
            VITE_DOWNLOAD_URL_LINUX?: string;
        };
    }
}

const getEnvVar = (key: keyof ImportMetaEnv): string => {
    return window.ENV?.[key as keyof Window['ENV']] || import.meta.env[key];
};

const getBooleanEnvVar = (key: keyof ImportMetaEnv): boolean => {
    return getEnvVar(key) === 'true';
};

const getOptionalEnvVar = (key: keyof ImportMetaEnv): string | undefined => {
    const value = getEnvVar(key);
    return value ? value : undefined;
};

export const config = {
    frontendUrl: getEnvVar('VITE_FRONTEND_URL'),
    backendUrl: getEnvVar('VITE_VELA_WEB_PORTAL_BACKEND_URL'),
    trackI18nKeys: getBooleanEnvVar('VITE_TRACK_I18N_KEYS'),
    downloadUrlWindows: getOptionalEnvVar('VITE_DOWNLOAD_URL_WINDOWS'),
    downloadUrlMac: getOptionalEnvVar('VITE_DOWNLOAD_URL_MAC'),
    downloadUrlLinux: getOptionalEnvVar('VITE_DOWNLOAD_URL_LINUX')
};
